import React from "react";
import { Link } from "react-router-dom";
import { LuFileText, LuMapPin, LuPhone, LuTrendingUp, LuWallet } from "react-icons/lu";
import LanguageToggle from "../../common/LanguageToggle";
import { useCiT } from "../../common/ci/i18n";

/**
 * Header ke upar ki patli navy patti (design canvas ka top strip, ticket 2.2).
 *
 * Char bharose ki baatein ek line me: kahan hain, GST bill, dealer credit,
 * sampark — aur daayein EN | हिं toggle. Mobile par ye patti nahi dikhti;
 * wahan sticky navy header khud ye kaam karta hai.
 */
const TopStrip: React.FC = () => {
  const t = useCiT();
  const item = "flex items-center gap-1.5 whitespace-nowrap";

  return (
    <div className="hidden w-full bg-ci-navy text-ci-stripfg sm:block">
      <div className="mx-auto flex h-[34px] max-w-[1440px] items-center justify-between gap-4 px-5 text-[12.5px]">
        <div className="flex items-center gap-5 overflow-hidden">
          <span className={item}>
            <LuMapPin size={14} aria-hidden="true" />
            {t("Rudrapur, Uttarakhand")}
          </span>
          <Link to="/rate-today" className={`${item} font-semibold hover:text-white`}>
            <LuTrendingUp size={14} aria-hidden="true" />
            {t("Aaj ka rate")}
          </Link>
          <span className={`${item} hidden md:flex`}>
            <LuFileText size={14} aria-hidden="true" />
            {t("GST bill seedha ERP se")}
          </span>
          <span className={`${item} hidden lg:flex`}>
            <LuWallet size={14} aria-hidden="true" />
            {t("Dealer credit")}
          </span>
        </div>

        <div className="flex items-center gap-4">
          <Link to="/contactus" className={`${item} hover:text-white`}>
            <LuPhone size={14} aria-hidden="true" />
            {t("Sampark karein")}
          </Link>
          <LanguageToggle />
        </div>
      </div>
    </div>
  );
};

export default TopStrip;
